export const ItemPriceSaleAndFeesInfoButtonViewLocalization = {
  limitedTimeNotice: $localize`:@@ideal-item-price-sale-and-fees-info-button-view.notice.limited-time:Limited Time`,
  feesNotice: $localize`:@@ideal-item-price-sale-and-fees-info-button-view.notice.fees:+Fees`,
  limitedTimeAndFeesNotice: $localize`:@@ideal-item-price-sale-and-fees-info-button-view.notice.limited-time-and-fees:Limited Time + Fees`,
} as const;
